<mat-card-content>
  <mat-card-title class="d-flex flex-row align-items-center mat-bold">
    <span>{{script.scriptDate | date:'yyyy-MM-dd'}}</span>
    <span class="script ms-3"> {{script.scriptType | scriptTypeFormatter}}</span>
    <div class="flex-spacer"></div>
    @if (canDelete) {
      <button
        mat-icon-button
        xuiConfirmationDialog
        [confirmMessage]="deleteConfirmationMessage"
        (confirm)="delete(script.id)"
        *xuiPermissionRequired="'Clinical.Scripts.Delete'"
        aria-label="Delete script">
        <mat-icon>delete</mat-icon>
      </button>
    }
    <button mat-icon-button *xuiPermissionRequired="'Clinical.Documents.Write'" (click)="print(script.id)" [disabled]="printing" aria-label="Print script"><mat-icon>print</mat-icon></button>
  </mat-card-title>
  <mat-card-subtitle class="d-flex flex-row justify-content-between">
    <span>{{script.createdDateUtc | practiceDateTime:'yyyy-MM-dd HH:mm'}}</span>
    <span>{{script.createdUser.firstName}} {{script.createdUser.surname}}</span>
  </mat-card-subtitle>
</mat-card-content>
<mat-divider></mat-divider>
